import React from 'react';
import Products2Hero from '../components/Products2Hero';
import './ShippingPage.css';
import DeliveryChecker from '../components/DeliveryChecker';

const ShippingPage = () => {
  return (
    <div className="shipping-page">
      <Products2Hero 
        className="hero-tight"
        tagline="GLOBAL TRACKING · SECURE PACKAGING · FAST FULFILLMENT"
        title1="Shipping Policy"
        title2=""
        title3=""
        description=""
        button1Text="Check Pincode"
        button1Link="#delivery-checker"
        button2Text="Delivery Policy"
        button2Link="#shipping-content"
      />
      <div className="container">
        <div id="delivery-checker">
          <DeliveryChecker />
        </div>
        <div id="shipping-content" className="shipping-content">
          <div className="shipping-section">
            <p className="section-text">
              For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 0-7 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 0-7 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on 6303561201 or support@nexawavetechnology.com
            </p>
          </div>

          <div className="note-box">
            <p>
              Disclaimer: The above content is created at NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED's sole discretion. Razorpay shall not be liable for any content provided here and shall not be responsible for any claims and liability that may arise due to merchant’s non-adherence to it.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPage;
